import { render } from "./App.vue?vue&type=template&id=356d5d3e&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=356d5d3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-356d5d3e"

export default script